import {
  BASE_ANNUAL_MEMBERSHIP_PRICE
} from "./store.constants"
import {
  BILLING_INTERVAL_TYPES,
  INTERVAL_DAYS,
} from "@/store/payment/payment.constants"
import { GET_BENEFITS_V2 } from "@/constants/membership"

export const convertIntervalPeriods = (fromInterval, toInterval) => {
  const fromDays = INTERVAL_DAYS[fromInterval]
  const toDays = INTERVAL_DAYS[toInterval]
  return Math.floor(fromDays / toDays)
}

export const convertIntervalBasePrice = (fromInterval, toInterval, fromBasePrice) => {
  const numPeriods = convertIntervalPeriods(fromInterval, toInterval)
  return fromBasePrice / numPeriods
}

export const getSubscriptionProductStoreDetails = (subscriptionProduct) => {
  if (!subscriptionProduct) {
    return null
  }

  const discountPerk = (subscriptionProduct.perks ?? [])
    .find(perk => perk.identifier === "pg_points_discount")
  const creditDiscount = discountPerk?.percentage ?? null

  const perks = [
    ...(subscriptionProduct.initial_perks || []),
    ...subscriptionProduct.perks,
  ]
  const creditIssuedInPoints = perks
    .reduce((acc, perk) => {
      const points = perk.identifier === "pg_points"
        ? (perk.amount ?? 0)
        : 0
      return acc + points
    }, 0)

  const billingDetails = subscriptionProduct?.billing_details.regular
  const billedPrice = billingDetails?.price.amount ?? BASE_ANNUAL_MEMBERSHIP_PRICE
  const billedInterval = billingDetails?.interval_type ?? BILLING_INTERVAL_TYPES.YEAR
  let displayInterval
  switch (billedInterval) {
    case BILLING_INTERVAL_TYPES.YEAR:
      displayInterval = BILLING_INTERVAL_TYPES.MONTH
      break
    default:
      displayInterval = billedInterval
  }

  const numPeriods = convertIntervalPeriods(billedInterval, displayInterval)
  const pricePerDisplayedInterval = billedPrice / numPeriods
  const basePricePerDisplayedInterval = convertIntervalBasePrice(
    BILLING_INTERVAL_TYPES.YEAR,
    displayInterval,
    BASE_ANNUAL_MEMBERSHIP_PRICE
  )
  const benefits = GET_BENEFITS_V2({
    percentDiscount: creditDiscount,
    freePoints: creditIssuedInPoints,
  }) ?? []

  return {
    billedInterval,
    billedPrice,
    displayInterval,
    pricePerDisplayedInterval,
    basePricePerDisplayedInterval,
    benefits,
  }
}



// WEBPACK FOOTER //
// ./src/store/store/store.utils.js